import React, { useEffect, useState } from 'react';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { FinalCTA } from './components/FinalCTA';
import { HomePage } from './pages/HomePage';
import { HumanCapabilityPage } from './pages/HumanCapabilityPage';
import { SemanticKnowledgePage } from './pages/SemanticKnowledgePage';
import { CJIPage } from './components/CJIPage';
import { NCJIPage } from './components/NCJIPage';
import { SolutionsPage } from './components/SolutionsPage';
import { AboutPage } from './components/AboutPage';
import { ResearchPage } from './pages/ResearchPage';
import { ResearchAreasPage } from './pages/ResearchAreasPage';
import { PartnershipsPage } from './components/PartnershipsPage';
import { ContactPage } from './components/ContactPage';
import { PrivacyPolicyPage } from './components/PrivacyPolicyPage';
import { TermsOfServicePage } from './components/TermsOfServicePage';
import { GovernmentPage } from './components/GovernmentPage';
import { EducationPage } from './components/EducationPage';
import { EmployersPage } from './components/EmployersPage';
import { CivilSocietyPage } from './components/CivilSocietyPage';
import { LeadershipPage } from './components/LeadershipPage';
import { ReasoningQualityPage } from './components/ReasoningQualityPage';
import { ConsequentialThinkingPage } from './components/ConsequentialThinkingPage';
import { ManipulationResistancePage } from './components/ManipulationResistancePage';
import { EmotionalRegulationPage } from './components/EmotionalRegulationPage';
import { SocialCooperationPage } from './components/SocialCooperationPage';
import { SelfDirectionPage } from './components/SelfDirectionPage';
import { LeadershipResponsibilityPage } from './components/LeadershipResponsibilityPage';
import { IndividualLevelPage } from './components/IndividualLevelPage';
import { OrganizationalLevelPage } from './components/OrganizationalLevelPage';
import { MunicipalScalePage } from './components/MunicipalScalePage';
import { NationalScalePage } from './components/NationalScalePage';
type RouteConfig = {
  page: React.ComponentType;
  withCTA: boolean;
};
const routes: Record<string, RouteConfig> = {
  '/': {
    page: HomePage,
    withCTA: false
  },
  '/human-capability': {
    page: HumanCapabilityPage,
    withCTA: false
  },
  '/semantic-knowledge': {
    page: SemanticKnowledgePage,
    withCTA: false
  },
  '/cji': {
    page: CJIPage,
    withCTA: true
  },
  '/ncji': {
    page: NCJIPage,
    withCTA: true
  },
  '/solutions': {
    page: SolutionsPage,
    withCTA: true
  },
  '/about': {
    page: AboutPage,
    withCTA: false
  },
  '/research': {
    page: ResearchPage,
    withCTA: false
  },
  '/research-areas': {
    page: ResearchAreasPage,
    withCTA: false
  },
  '/partnerships': {
    page: PartnershipsPage,
    withCTA: true
  },
  '/contact': {
    page: ContactPage,
    withCTA: true
  },
  '/privacy': {
    page: PrivacyPolicyPage,
    withCTA: false
  },
  '/terms': {
    page: TermsOfServicePage,
    withCTA: false
  },
  '/government': {
    page: GovernmentPage,
    withCTA: true
  },
  '/education': {
    page: EducationPage,
    withCTA: true
  },
  '/employers': {
    page: EmployersPage,
    withCTA: true
  },
  '/civil-society': {
    page: CivilSocietyPage,
    withCTA: true
  },
  '/leadership': {
    page: LeadershipPage,
    withCTA: true
  },
  '/reasoning-quality': {
    page: ReasoningQualityPage,
    withCTA: true
  },
  '/consequential-thinking': {
    page: ConsequentialThinkingPage,
    withCTA: true
  },
  '/manipulation-resistance': {
    page: ManipulationResistancePage,
    withCTA: true
  },
  '/emotional-regulation': {
    page: EmotionalRegulationPage,
    withCTA: true
  },
  '/social-cooperation': {
    page: SocialCooperationPage,
    withCTA: true
  },
  '/self-direction': {
    page: SelfDirectionPage,
    withCTA: true
  },
  '/leadership-responsibility': {
    page: LeadershipResponsibilityPage,
    withCTA: true
  },
  '/individual-level': {
    page: IndividualLevelPage,
    withCTA: true
  },
  '/organizational-level': {
    page: OrganizationalLevelPage,
    withCTA: true
  },
  '/municipal-scale': {
    page: MunicipalScalePage,
    withCTA: true
  },
  '/national-scale': {
    page: NationalScalePage,
    withCTA: true
  }
};
export function App() {
  const [path, setPath] = useState(getInitialPath);
  useEffect(() => {
    const handlePopState = () => {
      setPath(normalizePath(window.location.pathname));
      window.scrollTo(0, 0);
    };
    const handleClick = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      const anchor = (event.target as HTMLElement).closest('a');
      if (!anchor || anchor.target === '_blank') return;
      const href = anchor.getAttribute('href');
      if (!href || !href.startsWith('/') || href.startsWith('//')) return;
      event.preventDefault();
      const nextPath = normalizePath(href);
      if (nextPath !== window.location.pathname) {
        window.history.pushState({}, '', nextPath);
      }
      setPath(nextPath);
      window.scrollTo(0, 0);
    };
    window.addEventListener('popstate', handlePopState);
    document.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('popstate', handlePopState);
      document.removeEventListener('click', handleClick);
    };
  }, []);
  const route = routes[path] ?? routes['/'];
  const Page = route.page;
  return <div className="min-h-screen bg-surface-bg font-body text-ink-dark selection:bg-teal selection:text-white" data-id="element-0" data-mp="29xehmm5j2zt1">
      <Navigation data-id="element-1" data-mp="2eun3awpvxlz1" />
      <main data-id="element-2" data-mp="2ex950fq3h79c">
        <Page data-id="element-3" data-mp="2jtr87b5s0xjk" />
        {route.withCTA && <FinalCTA data-id="element-4" data-mp="2jsycr6c9pugq" />}
      </main>
      <Footer data-id="element-5" data-mp="2jw40ah590oac" />
    </div>;
}
function normalizePath(pathname: string) {
  const clean = pathname.replace(/\/+$/, '');
  return clean === '' ? '/' : clean;
}

// Old links used "#page" addresses (e.g. /#cji). Redirect them to clean paths.
function getInitialPath() {
  const legacy = window.location.hash.slice(1);
  if (legacy) {
    const legacyPath = legacy === 'home' ? '/' : `/${legacy}`;
    if (routes[legacyPath]) {
      window.history.replaceState({}, '', legacyPath);
      return legacyPath;
    }
  }
  return normalizePath(window.location.pathname);
}